import { Outlet } from "react-router-dom";
import './_hcp-layout.scss';
import StickyHeader from "../../components/sticky-header";
import LayoutContextContainer from '../../components/layout-context-container';
import HcpUtilNav from "../../components-hcp/util-nav";
import HcpHeader from "../../components-hcp/header";
import PatientInterstitial from "../../components/interstitial";

function HcpLayout() {

  return (
    <div className="hcp-layout">
      <LayoutContextContainer>
        <StickyHeader>
          <HcpUtilNav />
          <HcpHeader />
        </StickyHeader>
        <Outlet />
        <PatientInterstitial />
      </LayoutContextContainer>
    </div>
  );
}

export default HcpLayout;